import { Clock, Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react'

const LandingFooter = () => {
  const currentYear = new Date().getFullYear()

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    const element = document.querySelector(href)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const footerLinks = {
    navigation: [
      { href: '#solucao', label: 'Solução' },
      { href: '#beneficios', label: 'Benefícios' },
      { href: '#funcionalidades', label: 'Funcionalidades' },
      { href: '#faq', label: 'FAQ' },
      { href: '#contato', label: 'Contato' }
    ],
    resources: [
      { href: '#blog', label: 'Blog' },
      { href: '#documentacao', label: 'Documentação' },
      { href: '#suporte', label: 'Central de Ajuda' },
      { href: '#api', label: 'API' },
      { href: '#downloads', label: 'Downloads' }
    ],
    contact: [
      { icon: Mail, text: 'contato@flowclock.com.br', href: 'mailto:contato@flowclock.com.br' },
      { icon: Phone, text: '(11) 3000-0000', href: 'tel:+551130000000' },
      { icon: MapPin, text: 'Av. Paulista, 1000 - São Paulo, SP', href: null }
    ],
    social: [
      { icon: Facebook, label: 'Facebook', href: 'https://facebook.com' },
      { icon: Instagram, label: 'Instagram', href: 'https://instagram.com' },
      { icon: Linkedin, label: 'LinkedIn', href: 'https://linkedin.com' },
      { icon: Twitter, label: 'Twitter', href: 'https://twitter.com' }
    ]
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About Column */}
          <div>
            <a href="#hero" className="flex items-center gap-3 mb-6 group">
              <Clock size={32} className="text-primary-500" />
              <span className="text-xl font-extrabold">Flow Clock</span>
            </a>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Solução completa de controle de ponto e gestão de RH digital. 
              Conforme a legislação brasileira e LGPD.
            </p>
            <div className="flex gap-4">
              {footerLinks.social.map((social) => {
                const Icon = social.icon
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="w-10 h-10 rounded-lg bg-gray-800 hover:bg-primary-600 flex items-center justify-center transition-all duration-200 hover:-translate-y-1"
                  >
                    <Icon size={18} />
                  </a>
                )
              })}
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h3 className="font-bold text-lg mb-6">Navegação</h3>
            <ul className="space-y-3">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-gray-400 hover:text-primary-500 transition-colors duration-200 inline-block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h3 className="font-bold text-lg mb-6">Recursos</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-gray-400 hover:text-primary-500 transition-colors duration-200 inline-block">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="font-bold text-lg mb-6">Contato</h3>
            <ul className="space-y-4">
              {footerLinks.contact.map((contact, index) => {
                const Icon = contact.icon
                return (
                  <li key={index} className="flex items-start gap-3">
                    <Icon size={18} className="text-primary-500 mt-1 flex-shrink-0" />
                    {contact.href ? (
                      <a href={contact.href} className="text-gray-400 hover:text-primary-500 transition-colors duration-200 text-sm">
                        {contact.text}
                      </a>
                    ) : (
                      <span className="text-gray-400 text-sm">{contact.text}</span>
                    )}
                  </li>
                )
              })}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Flow Clock. Todos os direitos reservados.
            </p>
            <div className="flex flex-wrap items-center gap-6 text-sm">
              <a href="#privacy" className="text-gray-400 hover:text-primary-500 transition-colors duration-200">
                Política de Privacidade
              </a>
              <span className="text-gray-600">•</span>
              <a href="#terms" className="text-gray-400 hover:text-primary-500 transition-colors duration-200">
                Termos de Uso
              </a>
              <span className="text-gray-600">•</span>
              <a href="#lgpd" className="text-gray-400 hover:text-primary-500 transition-colors duration-200">
                LGPD
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default LandingFooter
